import React, { FC } from 'react';

import { HOME_PAGE_CONTENT } from '@constants/element-ids';
import Layout from 'modules/Core';

import { BlockCards, FooterCallOut, HomeSplash, NumbersShowcase } from '../modules/Home/components';
import { Content, MiddleBackground } from './styles';

const HomePage: FC = () => {
  return (
    <>
      <Layout innerPadding={false}>
        <HomeSplash />
        <MiddleBackground />
        <Content id={HOME_PAGE_CONTENT}>
          <NumbersShowcase />
        </Content>
        <FooterCallOut />
      </Layout>
    </>
  );
};

export default HomePage;
